import React, { useEffect, useRef } from 'react';
import axios from 'axios';


const updateVersion = async (version, adjid) => {
  try {
    const accessToken = localStorage.getItem("accessToken")
    const response = await axios
    .patch(`${window.__RUNTIME_CONFIG__.REACT_APP_API_URL}adjudicator/update/`, {imageVersion: version, adjid: adjid }, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
  } catch (error) {
    console.log(error)

  }

}

const CloudinaryUploadWidget = ({ uwConfig, setPublicId, setImageUrl, adjid }) => {
  const uploadWidgetRef = useRef(null);
  const uploadButtonRef = useRef(null);


  useEffect(() => {

    const initializeUploadWidget = () => {
      if (window.cloudinary && uploadButtonRef.current && uwConfig.uploadSignature) {

        uploadWidgetRef.current = window.cloudinary.createUploadWidget(
          uwConfig,
          (error, result) => {
            if (!error && result) {
              if (result.event === "success"){

                updateVersion(result.info.version, adjid)
                setPublicId(result.info.public_id);
                setImageUrl(result.info.secure_url);
              }
              if (result.event === "close") {
                document.body.style.overflow = "auto";

              }
            }
          }
        );

        // Add click event to open widget
        const handleUploadClick = () => {
          if (uploadWidgetRef.current) {
            document.body.style.overflow = "hidden";
            uploadWidgetRef.current.open();
          }

        };

        const buttonElement = uploadButtonRef.current;
        buttonElement.addEventListener('click', handleUploadClick);

        return () => {
          buttonElement.removeEventListener('click', handleUploadClick);
        };
      }
    };

    initializeUploadWidget();
  }, [uwConfig, setPublicId]); // Re-run if uwConfig changes

  return (
    <button
      ref={uploadButtonRef}
      id="upload_widget"


    >
      <i className='fa-regular fa-pen-to-square text-[16px] bg-[#232323] text-white p-2 rounded'></i>
    </button>
  );
};

export default CloudinaryUploadWidget;
